import { craftsmanshipImages } from '../../../utils/images';

export default function CraftsmanshipSection() {
  const crafts = [
    {
      name: "SCREEN PRINT",
      description: "Professional screen printing techniques for vibrant and durable fabric designs",
      image: craftsmanshipImages.screenPrint
    },
    {
      name: "HAND-MADE RUB",
      description: "Traditional hand-rubbing techniques creating unique surface textures and finishes",
      image: craftsmanshipImages.handMadeRub
    },
    {
      name: "HEAT PRESS",
      description: "Advanced heat press technology for precise and lasting fabric applications",
      image: craftsmanshipImages.heatPress
    },
    {
      name: "HAND-STITCH",
      description: "Artisanal hand-stitching methods ensuring superior quality and attention to detail",
      image: craftsmanshipImages.handStitch
    },
    {
      name: "GARMENT DYE",
      description: "Specialized garment dyeing processes for rich, consistent color development",
      image: craftsmanshipImages.garmentDye
    },
    {
      name: "DOUBLE SIDE LEATHER",
      description: "Premium double-sided leather treatments for luxurious reversible designs",
      image: craftsmanshipImages.doubleSideLeather
    },
    {
      name: "SEAM-LESS",
      description: "Innovative seamless construction techniques for enhanced comfort and modern aesthetics",
      image: craftsmanshipImages.seamLess
    },
    {
      name: "EMBROIDERY PATTERN",
      description: "Intricate embroidery patterns adding artistic detail and brand distinction",
      image: craftsmanshipImages.embroideryPattern
    },
    {
      name: "EMBROIDERY STITCH",
      description: "Precision embroidery stitching techniques creating detailed and durable designs",
      image: craftsmanshipImages.embroideryStitch
    },
    {
      name: "BONDING",
      description: "Advanced fabric bonding technology for enhanced durability and performance",
      image: craftsmanshipImages.bonding
    },
    {
      name: "DIGITAL PRINT",
      description: "State-of-the-art digital printing for intricate designs and photographic quality",
      image: craftsmanshipImages.digitalPrint
    },
    {
      name: "LEATHER GARMENT WASHING",
      description: "Specialized leather washing techniques creating unique textures and enhanced suppleness",
      image: craftsmanshipImages.leatherGarmentWashing
    }
  ];

  return (
    <section className="py-20" style={{ backgroundColor: '#fff' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-light text-gray-900 leading-tight" style={{ fontSize: '32px' }}>
            Craftsmanship Excellence
          </h2>
        </div>

        {/* Craftsmanship Grid - First Row (6 items) */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 mb-12">
          {crafts.slice(0, 6).map((craft, index) => (
            <div
              key={index}
              className="text-center mb-0"
            >
              {/* Circular Image Container */}
              <div className="w-28 h-28 mx-auto mb-4 rounded-full overflow-hidden ring-2 ring-gray-100 p-0">
                <img
                  src={craft.image}
                  alt={craft.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <h3 className="text-sm font-normal text-gray-900 leading-tight">
                {craft.name}
              </h3>
            </div>
          ))}
        </div>

        {/* Craftsmanship Grid - Second Row (6 items) */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
          {crafts.slice(6, 12).map((craft, index) => (
            <div
              key={index + 6}
              className="text-center mb-0"
            >
              {/* Circular Image Container */}
              <div className="w-28 h-28 mx-auto mb-4 rounded-full overflow-hidden ring-2 ring-gray-100 p-0">
                <img
                  src={craft.image}
                  alt={craft.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <h3 className="text-sm font-normal text-gray-900 leading-tight">
                {craft.name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}